module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_iter-step.js
// module id = 39
// module chunks = 0